// React component

import { motion } from "framer-motion";
import { Code2, GitBranch, GitCommit, GitPullRequest } from "lucide-react";

const DevelopmentMetrics = () => {
  const metrics = [
    {
      icon: Code2,
      label: "Lines of Code",
      value: "2.5M+",
      color: "text-blue-500",
    },
    {
      icon: GitCommit,
      label: "Commits",
      value: "50K+",
      color: "text-purple-500",
    },
    {
      icon: GitBranch,
      label: "Branches",
      value: "1.2K+",
      color: "text-pink-500",
    },
    {
      icon: GitPullRequest,
      label: "Pull Requests",
      value: "8.5K+",
      color: "text-green-500",
    },
  ];

  return (
    <div
      className="w-full h-full relative bg-background/50 rounded-xl p-4 overflow-hidden"
      data-oid="wpa7bg3"
    >
      {/* Background gradient */}
      <div
        className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-purple-500/5 to-pink-500/5"
        data-oid=".cnka52"
      />

      {/* Metrics grid */}
      <div className="grid grid-cols-2 gap-4 relative z-10" data-oid="5e0b:gi">
        {metrics.map((metric, index) => (
          <motion.div
            key={metric.label}
            className="flex flex-col items-center justify-center p-4 rounded-lg bg-card/30 backdrop-blur-sm border border-border"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ scale: 1.05 }}
            data-oid="62yz2ot"
          >
            <metric.icon
              className={`h-6 w-6 ${metric.color} mb-2`}
              data-oid="xsk-ft3"
            />
            <span className="text-xs text-muted-foreground" data-oid="xoorqeh">
              {metric.label}
            </span>
            <span className="text-lg font-bold" data-oid="1tfg_eg">
              {metric.value}
            </span>
          </motion.div>
        ))}
      </div>

      {/* Animated connection lines */}
      <svg
        className="absolute inset-0 w-full h-full pointer-events-none"
        data-oid="su2w-ay"
      >
        <motion.path
          d="M 50,50 L 150,150 M 150,50 L 50,150 M 50,100 L 150,100"
          stroke="currentColor"
          strokeOpacity="0.1"
          strokeWidth="1"
          strokeDasharray="5,5"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, repeat: Infinity }}
          fill="none"
          data-oid=".d0hji_"
        />
      </svg>

      {/* Floating particles */}
      {Array.from({ length: 8 }).map((_, i) => (
        <motion.div
          key={`particle-${i}`}
          className="absolute h-1 w-1 rounded-full"
          style={{
            background: `var(--${["blue", "purple", "pink", "green"][i % 4]}-500)`,
          }}
          initial={{
            x: Math.random() * 100,
            y: Math.random() * 100,
            scale: 0,
          }}
          animate={{
            x: [Math.random() * 100, Math.random() * 100],
            y: [Math.random() * 100, Math.random() * 100],
            scale: [0, 1, 0],
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            delay: i * 0.2,
          }}
          data-oid="xve-7a4"
        />
      ))}
    </div>
  );
};

export default DevelopmentMetrics;
